module.exports = __webpack_public_path__ + "static/media/dashboard-icons.eb11b096.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/dashboard-icons.svg
// module id = 1516
// module chunks = 1